import { TextField } from "@material-ui/core";
import { KeyboardDatePicker } from "@material-ui/pickers";
import GenderAutocomplete from "./GenderAutocomplete";

const _spacing = "10px";

const SnqForm = props => {
  const handleChange = e => {
    const name = e.target.name;
    const value = e.target.value;
    props.setQueryState(prevState => {
      return { ...prevState, [name]: value };
    });
  };

  const handleDateChange = (date, str) => {
    props.setQueryState(prevState => {
      return { ...prevState, dob: str };
    });
  };

  return (
    <div
      data-testid="snq-form"
      id="bottom-half"
      style={{ display: "flex", flexDirection: "column", rowGap: "10px" }}
    >
      {props.children}
      <div
        id="group1"
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          border: "1px solid black",
          justifyContent: "space-between",
          padding: _spacing,
        }}
      >
        {/* eslint-disable-next-line jsx-a11y/no-autofocus -- Focus Name when this name query form opens. */}
        <TextField autoFocus
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          margin="dense"
          id="name-id"
          label="Name"
          helperText="Last Name, First Name Middle Initial"
          value={props?.queryState?.name || ""}
          onChange={handleChange}
          name="name"
          style={{ width: "45%" }}
        />
        <KeyboardDatePicker
          data-testid="dob"
          inputProps={{ "data-testid": "dob-input" }}
          autoOk
          variant="inline"
          inputVariant="outlined"
          label="Date of birth"
          value={props?.queryState?.dob || null}
          onChange={(date, str) => handleDateChange(date, str)}
          format="YYYYMMDD"
          helperText="Date format: YYYYMMDD"
          disableFuture={true}
          style={{ width: "45%" }}
        />
        <GenderAutocomplete
          value={props?.queryState?.gender}
          handleChange={handleChange}
        />
      </div>
    </div>
  );
};

export default SnqForm;
